var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { _PdfOpenJpegRunner } from './openjpeg-runner';
var _PdfImageProcessor = /** @class */ (function () {
    function _PdfImageProcessor() {
    }
    _PdfImageProcessor.prototype._decodeImage = function (bytes, jpxStream, platform) {
        return __awaiter(this, void 0, void 0, function () {
            var workerBob, workerBlobUrl, worker, _a, protocol, host, pathname, trimmedPathname, baseUrl, scriptLinkURL, splitURL, path, data, imagedata;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        workerBob = new Blob([_PdfOpenJpegRunner.toString().replace(/^[^{]*{([\s\S]*)}$/m, '$1')], { type: 'text/javascript' });
                        workerBlobUrl = URL.createObjectURL(workerBob);
                        worker = new Worker(workerBlobUrl);
                        _a = document.location, protocol = _a.protocol, host = _a.host, pathname = _a.pathname;
                        trimmedPathname = pathname.replace(/\/+$/, '');
                        baseUrl = protocol + "//" + host + trimmedPathname;
                        if (platform === 'angular') {
                            baseUrl = baseUrl + '/assets/ej2-pdf-lib';
                        }
                        else if (platform === 'vue') {
                            baseUrl = baseUrl + '/public/js/ej2-pdf-lib';
                        }
                        else {
                            window.getRunningScript = function () {
                                return function () {
                                    var stackTrace = new Error().stack;
                                    // eslint-disable-next-line
                                    var match = stackTrace && stackTrace.match(/(?:http[s]?:\/\/(?:[^\/\s]+\/))(.*\.js)/);
                                    return match ? match[0] : location.href;
                                };
                            };
                            scriptLinkURL = window.getRunningScript()();
                            splitURL = scriptLinkURL.split('/');
                            path = scriptLinkURL.replace('/' + splitURL[splitURL.length - 1], '');
                            if (platform === 'javascript' || platform === 'typescript' || platform === 'react' || platform === 'react' ||
                                platform === 'aspnetcore' || platform === 'aspnetmvc') {
                                baseUrl = path + '/ej2-pdf-lib';
                            }
                            else {
                                baseUrl = path.replace('import', 'ej2-pdf-lib');
                            }
                        }
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                worker.onmessage = function (event) {
                                    var msg = event.data; //eslint-disable-line
                                    if (msg.message === 'loaded') {
                                        resolve();
                                    }
                                    else if (msg.message === 'decodeError') {
                                        reject(new Error(msg.error));
                                    }
                                };
                                worker.postMessage({ message: 'initialLoading', url: baseUrl });
                            })];
                    case 1:
                        _b.sent();
                        data = bytes || jpxStream.bytes;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                worker.onmessage = function (event) {
                                    var msg = event.data; //eslint-disable-line
                                    imagedata = msg.message;
                                    resolve();
                                };
                                worker.postMessage({ message: 'decodeJPX', url: data });
                            })];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, imagedata];
                }
            });
        });
    };
    return _PdfImageProcessor;
}());
export { _PdfImageProcessor };
